import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ViewCC extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.handleLoad2 = this.handleLoad2.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setRepeatPassword = this.setRepeatPassword.bind(this);
    // this.handleClick = this.handleClick.bind(this);
    this.state = {
      data: {},
      rows: [],
      ccName: '',
      ccNumber: '',
      ccExpire: '',
      ccType: '',
      password: '',
      repeatPassword: '',
      step: 3,
      viewAlert: false,
      alertMsg: '',
    };
  }
  handleClickOpen() {
    //  setOpen(true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.resId !== this.props.resId) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'getCC2',
        token: token,
        Data: {
          ReservationId: this.props.resId,
        },
      };
      //    console.log('pms');

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      var mode = this.props.auth.authUser.clouduser;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data.hasCC != null && res.data.hasCC == 1) {
          this.setState({ step: 0, password: '' });
        } else this.setState({ step: 2, password: '', repeatPassword: '' });
      });
    }
  }

  handleLoad() {
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'getCC2',
      token: token,
      Version: 1,
      Data: {
        Password: this.state.password,
        ReservationId: this.props.resId,
      },
    };
    //    console.log('pms');

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data != null) {
        this.setState({
          viewAlert: false,
          step: 1,
          ccName: res.data.Data.ccName,
          ccNumber: res.data.Data.ccNumber,
          ccType: res.data.Data.ccType,
          ccExpire: res.data.Data.ccExpire,
        });
      } else {
        this.setState({ step: 0, viewAlert: true, alertMsg: 'Error in password' });
      }
    });
  }

  handleLoad2() {
    if (this.state.password != this.state.repeatPassword || this.state.password.length < 8) {
      this.setState({ step: 2, viewAlert: true, alertMsg: 'Error in password' });
      return;
    }
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'getCC2',
      token: token,
      Version: 1,
      Data: {
        NewPassword: this.state.password,
        ReservationId: this.props.resId,
      },
    };
    //    console.log('pms');

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data != null) {
        this.setState({
          viewAlert: false,
          step: 1,
          ccName: res.data.Data.ccName,
          ccNumber: res.data.Data.ccNumber,
          ccType: res.data.Data.ccType,
          ccExpire: res.data.Data.ccExpire,
        });
      } else {
        this.setState({ step: 2, viewAlert: true, alertMsg: 'Error in password' });
      }
    });
  }

  handleClose() {
    this.props.setState({ viewCCVisible: false });
    //  setOpen(false);
  }
  setPassword(x) {
    this.setState({ password: x });
  }
  setRepeatPassword(x) {
    this.setState({ repeatPassword: x });
  }

  handleRemove() {
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'removeCC',
      token: token,
      Version: 1,
      Data: {
        HotelId: '132',
        ReservationId: this.props.resId,
      },
    };
    //    console.log('pms');

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      this.props.setState({ viewCCVisible: false });
      this.setState({
        ccName: '',
        ccNumber: '',
        ccType: '',
        ccExpire: '',
      });
    });

    //  setOpen(false);
  }

  render() {
    const { classes } = this.props;
    var mode = this.props.auth.authUser.clouduser;

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            {this.state.step == 2 && (
              <>
                {this.state.viewAlert == true && (
                  <Box mb={2}>
                    <Alert severity="error">
                      <AlertTitle>Error</AlertTitle>
                      {parse(this.state.alertMsg)}
                    </Alert>
                  </Box>
                )}
                <Typography component="div" variant="p" className={classes.rootText}>
                  <IntlMessages id="profile.passwordChangeInto2" />
                  <br />
                </Typography>

                <TextField
                  type="password"
                  label=<IntlMessages id="profile.newPassword" />
                  fullWidth
                  onChange={event => this.setPassword(event.target.value)}
                  defaultValue={this.state.password}
                  margin="normal"
                  variant="outlined"
                  className={classes.textFieldRoot}
                />
                <TextField
                  type="password"
                  label=<IntlMessages id="profile.repeatNewPassword" />
                  fullWidth
                  onChange={event => this.setRepeatPassword(event.target.value)}
                  defaultValue={this.state.repeatPassword}
                  margin="normal"
                  variant="outlined"
                  className={classes.textFieldRoot}
                />

                <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleLoad2()}>
                  <IntlMessages id="profile.setChange" />
                </Button>
              </>
            )}
            {this.state.step == 0 && (
              <>
                {this.state.viewAlert == true && (
                  <Box mb={2}>
                    <Alert severity="error">
                      <AlertTitle>Error</AlertTitle>
                      {parse(this.state.alertMsg)}
                    </Alert>
                  </Box>
                )}

                <TextField
                  type="password"
                  label=<IntlMessages id="appModule.password" />
                  fullWidth
                  onChange={event => this.setPassword(event.target.value)}
                  defaultValue={this.state.password}
                  margin="normal"
                  variant="outlined"
                  className={classes.textFieldRoot}
                />
                <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleLoad()}>
                  <IntlMessages id="viewCC" />
                </Button>
              </>
            )}
            {this.state.step == 1 && (
              <>
                <Typography sx={{ p: 2 }}>
                  <IntlMessages id="viewCC.ccName" />
                  {this.state.ccName}
                </Typography>
                <Typography sx={{ p: 2 }}>
                  <IntlMessages id="viewCC.ccNumber" />
                  {this.state.ccNumber}
                </Typography>
                <Typography sx={{ p: 2 }}>
                  <IntlMessages id="viewCC.ccType" />
                  {this.state.ccType}
                </Typography>
                <Typography sx={{ p: 2 }}>
                  <IntlMessages id="viewCC.ccExpire" />
                  {this.state.ccExpire}
                </Typography>
                <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleClose()}>
                  <IntlMessages id="viewCC.close" />
                </Button>
                <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleRemove()}>
                  <IntlMessages id="viewCC.removeCC" />
                </Button>
              </>
            )}
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(ViewCC));
